/* eslint-disable import/no-import-module-exports */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import siteDe from './locales/de/site.json';
import siteEn from './locales/en/site.json';
import appDe from './locales/de/app.json';
import appEn from './locales/en/app.json';
import dashboardEn from './pages/locales/en/dashboard.json';
import dashboardDe from './pages/locales/de/dashboard.json';
import headerEn from './pages/locales/en/header.json';
import headerDe from './pages/locales/de/header.json';
import alertsEn from './elements/locales/en/alerts.json';
import alertsDe from './elements/locales/de/alerts.json';
import invitationEn from './elements/locales/en/invitation.json';
import invitationDe from './elements/locales/de/invitation.json';
import messagesEn from './elements/locales/en/messages.json';
import messagesDe from './elements/locales/de/messages.json';
import addAccountEn from './sections/addAccount/locales/en/addAccount.json';
import addAccountDe from './sections/addAccount/locales/de/addAccount.json';
import accountDetailsEn from './sections/accountDetails/locales/en/accountDetails.json';
import accountDetailsDe from './sections/accountDetails/locales/de/accountDetails.json';
import settingsEn from './sections/settings/locales/en/settings.json';
import settingsDe from './sections/settings/locales/de/settings.json';
import chartsEn from './sections/reports/locales/en/charts.json';
import chartsDe from './sections/reports/locales/de/charts.json';
import reportingEn from './sections/reports/locales/en/reporting.json';
import reportingDe from './sections/reports/locales/de/reporting.json';
import projectsEn from './sections/projects/locales/en/projects.json';
import projectsDe from './sections/projects/locales/de/projects.json';
import rebalancingEn from './sections/rebalancing/locales/en/rebalancing.json';
import rebalancingDe from './sections/rebalancing/locales/de/rebalancing.json';

const resources = {
  en: {
    site: siteEn,
    app: appEn,
    header: headerEn,
    dashboard: dashboardEn,
    charts: chartsEn,
    reporting: reportingEn,
    addAccount: addAccountEn,
    accountDetails: accountDetailsEn,
    settings: settingsEn,
    alerts: alertsEn,
    invitation: invitationEn,
    messages: messagesEn,
    projects: projectsEn,
    rebalancing: rebalancingEn,
  },
  de: {
    site: siteDe,
    app: appDe,
    header: headerDe,
    dashboard: dashboardDe,
    charts: chartsDe,
    reporting: reportingDe,
    addAccount: addAccountDe,
    accountDetails: accountDetailsDe,
    settings: settingsDe,
    alerts: alertsDe,
    invitation: invitationDe,
    messages: messagesDe,
    projects: projectsDe,
    rebalancing: rebalancingDe,
  },
};

const registerResourceBundles = () => {
  Object.entries(resources).forEach(([lng, namespaces]) => {
    Object.entries(namespaces).forEach(([ns, data]) => {
      if (i18n.hasResourceBundle(lng, ns)) {
        i18n.removeResourceBundle(lng, ns);
      }
      i18n.addResourceBundle(lng, ns, data);
    });
  });
};

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: false,
      fallbackLng: (code) => {
        if (!code?.startsWith('de')) return 'en';
        return ['de', 'en'];
      },
      supportedLngs: ['en', 'de'],
      detection: {
        order: ['path', 'localStorage', 'cookie', 'sessionStorage', 'navigator'],
      },
      interpolation: {
        escapeValue: false,
      },
      resources,
    });
} else {
  registerResourceBundles();
  i18n.reloadResources();
}

if (module.hot) {
  module.hot.accept(
    [
      './locales/de/site.json',
      './locales/en/site.json',
      './locales/de/app.json',
      './locales/en/app.json',
      './pages/locales/en/header.json',
      './pages/locales/de/header.json',
      './pages/locales/en/dashboard.json',
      './pages/locales/de/dashboard.json',
      './sections/reports/locales/en/charts.json',
      './sections/reports/locales/de/charts.json',
      './sections/reports/locales/en/reporting.json',
      './sections/reports/locales/de/reporting.json',
      './sections/addAccount/locales/en/addAccount.json',
      './sections/addAccount/locales/de/addAccount.json',
      './sections/accountDetails/locales/en/accountDetails.json',
      './sections/accountDetails/locales/de/accountDetails.json',
      './sections/settings/locales/en/settings.json',
      './sections/settings/locales/de/settings.json',
      './elements/locales/en/alerts.json',
      './elements/locales/de/alerts.json',
      './elements/locales/en/invitation.json',
      './elements/locales/de/invitation.json',
      './elements/locales/en/messages.json',
      './elements/locales/de/messages.json',
      './sections/projects/locales/en/projects.json',
      './sections/projects/locales/de/projects.json',
      './sections/rebalancing/locales/en/rebalancing.json',
      './sections/rebalancing/locales/de/rebalancing.json',
    ],
    () => {
      registerResourceBundles();
      i18n.reloadResources();
    },
  );
}

export default i18n;
